import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./assets/global.css";
import "normalize.css";
import "rsuite/dist/rsuite.min.css";

import Login from "./Pages/Login/Login";
import SandBox from "./Pages/SandBox/SandBox";
import Settings from "./Pages/Settings/Settings";
import Components from "./Pages/Components/Components";
import Counters from "./Pages/Counters/Counters";
import Jobs from "./Pages/Jobs/Jobs";
import WorkOrders from "./Pages/WorkOrders/WorkOrders";
import NotAuthorized from "./Pages/NotAuthorized/NotAuthorized";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Parts from "./Pages/Parts/Parts";
import CertificateName from "./Pages/CertificateName/CertificateName";
import PurchaseOrders from "./Pages/PurchaseOrders/PurchaseOrders";
import Certificates from "./Pages/Certificates/Certificates";
import Documents from "Pages/Documents/Documents";
import Manufacturers from "./Pages/Manufacturers/Manufacturers";
import Vendors from "./Pages/Vendors/Vendors";
import Invoices from "Pages/Workflows/Invoices/Invoices";
import Emails from "Pages/Workflows/Emails/Emails";
import RequireAccess from "./Components/RequireAccess/RequireAccess";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

function App() {
  React.useEffect(() => {
    const HOUR_MS = 60 * 60 * 1000;
    let notified = false;
    const check = async () => {
      if (notified) return;
      try {
        const res = await fetch("/version.json", { cache: "no-store" });
        if (!res.ok) return;
        const { version } = await res.json();
        const current = process.env.REACT_APP_VERSION;
        if (version && current && version !== current) {
          notified = true;
          toast.info(
            ({ closeToast }) => (
              <div>
                <div style={{ marginBottom: 8 }}>
                  A new version is available.
                </div>
                <button
                  onClick={() => window.location.reload()}
                  style={{
                    padding: "4px 12px",
                    border: "1px solid #d1d5db",
                    borderRadius: 4,
                    background: "#fff",
                    cursor: "pointer",
                    marginRight: 8,
                  }}
                >
                  Reload
                </button>
                <button
                  onClick={closeToast}
                  style={{
                    padding: "4px 12px",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    color: "#6b7280",
                  }}
                >
                  Later
                </button>
              </div>
            ),
            {
              position: "bottom-right",
              autoClose: false,
              closeOnClick: false,
              draggable: false,
            },
          );
        }
      } catch {}
    };
    const id = setInterval(check, HOUR_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <ToastContainer />

      <BrowserRouter>
        <MyComponent />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/401" element={<NotAuthorized />} />

          <Route path="/sandbox" element={<SandBox />} />
          <Route
            path="/settings"
            element={
              <RequireAccess>
                <Settings />
              </RequireAccess>
            }
          />
          <Route path="/components" element={<Components />} />
          <Route path="/counters" element={<Counters />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/workorders" element={<WorkOrders />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/purchase" element={<PurchaseOrders />} />
          <Route
            path="/certificates"
            element={
              <RequireAccess>
                <Certificates />
              </RequireAccess>
            }
          />
          <Route
            path="/certificatename"
            element={
              <RequireAccess>
                <CertificateName />
              </RequireAccess>
            }
          />
          <Route path="/parts" element={<Parts />} />
          <Route path="/manufacturers" element={<Manufacturers />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route
            path="/invoices"
            element={
              <RequireAccess>
                <Invoices />
              </RequireAccess>
            }
          />
          <Route
            path="/emails"
            element={
              <RequireAccess>
                <Emails />
              </RequireAccess>
            }
          />
          <Route
            path="/documents"
            element={
              <RequireAccess>
                <Documents />
              </RequireAccess>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

const MyComponent = () => {
  const location = useLocation();
  const { pathname } = location;
  React.useEffect(() => {
    console.log(pathname);
  }, [location]);
};
